export class TruckConstants {

  public static DEFAULT_TRUCK_HEIGHT = 4;
  public static DEFAULT_TRUCK_WIDTH = 2.5;
  public static DEFAULT_TRUCK_LENGTH = 16.5;
  public static DEFAULT_TRUCK_WEIGHT = 40000;
  public static DEFAULT_TRUCK_AXLE_WEIGHT: 11500;
  public static DEFAULT_AVOIDS = [];
  public static DEFAULT_STRATEGY = 'FASTEST';
  public static DEFAULT_TYPE = 'TRUCK';
  public static DEFAULT_EMISSION_TYPE = 'EURO6';
  public static DEFAULT_HAZARDOUS_GOODS = 'NONE';
}
